export default "__VITE_ASSET__CiR7V9wp__"